import { DialogTitle, WithStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Fab from '@material-ui/core/Fab';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Paper from '@material-ui/core/Paper';
import { createStyles, withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import AttachmentIcon from '@material-ui/icons/Attachment';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import PublishIcon from '@material-ui/icons/Publish';
import * as React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import * as Actions from 'src/actions/exerciseForm';
import { IMessage } from '../actions/message';
import MessageDialog from '../components/MessageDialog';
import TextField from '../components/TextFieldNoSubmit';
import { IRootState } from '../reducers';
import i18n from '../resources/i18n';
import ScenarioFactory, {
	IDeleteExerciseFileParam,
	IFetchExerciseStatusParam,
} from '../scenario/ExerciseFormScenarioFactory';
import { IELearningCommonProps } from './ELearning';

import SiteConfig from '../site.config.json';

import { push } from 'connected-react-router';
import ELearningScenarioFactory, {
	IFetchELearningProgressParam,
	IFetchELearningTreeParam,
} from '../scenario/ELearningScenarioFactory';
import { Routes, Screens } from '../utils/Routes';
import { funcClose } from '../utils/StartupUtils';

const styles = (theme: Theme) =>
	createStyles({
		paper: {
			margin: theme.spacing(1),
			padding: theme.spacing(3),
		},
		root: {
			flexGrow: 1,
			padding: theme.spacing(3),
		},
		wordBreak: {
			'word-break': 'break-all',
		},
	});

interface IState {
	uploadFile: string;
	uploadFilename: string;
	openErrorMessageDialog: boolean;
	openDeleteConfirm: boolean;
	openSubject: boolean;
	openDialog: boolean;
	messages: IMessage[];
}

/**
 * 課題提出コンポーネント
 */
export class ExerciseFormComponent extends React.Component<IProps, IState> {
	protected templateDownloadForm: React.RefObject<HTMLFormElement>;
	protected reportDownloadForm: React.RefObject<HTMLFormElement>;
	protected uploadForm: React.RefObject<HTMLFormElement>;
	protected uploadInput: React.RefObject<HTMLInputElement>;

	constructor(props: IProps) {
		super(props);

		this.state = {
			messages: [],
			openDeleteConfirm: false,
			openDialog: false,
			openErrorMessageDialog: false,
			openSubject: false,
			uploadFile: '',
			uploadFilename: '',
		};

		this.errorMessageDialogClose = this.errorMessageDialogClose.bind(this);
		this.templateDownloadForm = React.createRef();
		this.reportDownloadForm = React.createRef();
		this.uploadForm = React.createRef();
		this.uploadInput = React.createRef();
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidMount() {
		const {
			careerID,
			classID,
			init,
			preview: isPreview,
			userAttr: { userId },
		} = this.props;

		// 初期化アクション
		init({
			careerID,
			classID,
			isPreview,
			userId,
		});

		// 課題情報取得
		this.props.fetchExerciseStatus(this.props.token, {
			careerID: this.props.careerID,
			classID: this.props.classID,
			isPreview: this.props.preview,
			seq: this.props.seq,
			userAttr: this.props.userAttr,
		});
		if (this.props.subjectStatusflg === '1') {
			this.setState({ openSubject: true });
		}
	}

	/**
	 * Lifecycle Methods
	 */
	public componentWillUnmount() {
		this.props.clearExerciseFormParams();
	}

	/**
	 * Lifecycle Methods
	 */
	public componentDidUpdate(prevProps: IProps) {
		if (
			this.props.careerID === prevProps.careerID &&
			this.props.classID === prevProps.classID &&
			this.props.seq === prevProps.seq
		) {
			return;
		}
		// 課題情報取得
		this.props.fetchExerciseStatus(this.props.token, {
			careerID: this.props.careerID,
			classID: this.props.classID,
			isPreview: this.props.preview,
			seq: this.props.seq,
			userAttr: this.props.userAttr,
		});
		if (this.props.subjectStatusflg === '1') {
			this.setState({ openSubject: true });
		}
	}

	public render() {
		const { classes, careerID, classID, seq, flg } = this.props;
		const userId = this.props.userAttr.userId;

		return (
			<div className={classes.root}>
				<Grid container={true} spacing={3} alignItems="flex-end">
					<Grid item={true} xs={2}>
						<Typography variant="subtitle1" align="right">
							{i18n.t('ExerciseForm_0001')}
						</Typography>
					</Grid>
					<Grid item={true} className={classes.wordBreak}>
						<Typography variant="h5">
							{this.props.reportName}
						</Typography>
					</Grid>
				</Grid>

				<Paper className={classes.paper}>
					<Grid container={true} spacing={3} alignItems="center">
						<Grid item={true} xs={true} md={4}>
							<Typography variant="h6">
								{i18n.t('ExerciseForm_0002')}
							</Typography>
						</Grid>
						<Grid
							item={true}
							xs={true}
							md={true}
							className={classes.wordBreak}
						>
							<Typography>
								{this.props.reportTemplateFileName}
							</Typography>
						</Grid>
						<Grid item={true} xs={true} md={2}>
							<Fab
								color="primary"
								aria-label="Download"
								onClick={this.handleDownloadTemplate}
								disabled={
									this.props.displayDownloadButton
										? false
										: true
								}
							>
								<GetAppIcon />
							</Fab>
							<form
								method="POST"
								action={
									SiteConfig.tsqPath +
									'/tsq/pkg/action/el/reportTemplateFileDownload.action'
								}
								ref={this.templateDownloadForm}
								target="_blank"
							>
								<input
									type="hidden"
									name="searchCondition"
									value={`{"careerID":"${careerID}","seq":"${seq}"}`}
								/>
								<input
									type="hidden"
									name="__tsqCookieName"
									value="TSQ_FD_0"
								/>
								<input
									type="hidden"
									name="__tsqFileType"
									value="templateFile"
								/>
							</form>
						</Grid>
					</Grid>
				</Paper>

				<Paper className={classes.paper}>
					<Grid container={true} spacing={3} alignItems="center">
						<Grid item={true} xs={true} md={4}>
							<Typography variant="h6">
								{i18n.t('ExerciseForm_0003')}
							</Typography>
						</Grid>
						<Grid item={true} xs={true} md={true}>
							<form
								method="POST"
								action={
									SiteConfig.tsqPath +
									'/tsq/ui/common/resources/rest/file/upload'
								}
								encType="multipart/form-data"
								ref={this.uploadForm}
							>
								<FormControl>
									<TextField
										id="name"
										label={i18n.t('ExerciseForm_0004')}
										value={this.state.uploadFilename}
										onChange={this.handleUploadFilename}
										margin="normal"
										helperText={i18n.t('ExerciseForm_0005')}
									/>
									<Input
										type="text"
										value={this.getFilename(
											this.state.uploadFile
										)}
										disabled={true}
										fullWidth={true}
										endAdornment={
											<InputAdornment position="end">
												<IconButton
													onClick={
														this
															.handleClickAttachment
													}
												>
													<AttachmentIcon />
												</IconButton>
											</InputAdornment>
										}
									/>
									<input
										type="file"
										name="file"
										onChange={this.handleSelectFile}
										ref={this.uploadInput}
										style={{ display: 'none' }}
									/>
								</FormControl>
							</form>
						</Grid>
						{this.props.displayUploadButton && (
							<Grid item={true} xs={true} md={2}>
								<Fab
									color="primary"
									aria-label="Upload"
									onClick={this.handleUpload}
								>
									<PublishIcon />
								</Fab>
							</Grid>
						)}
					</Grid>
				</Paper>

				{this.props.displaySubmittedReportDownloadButton && (
					<Paper className={classes.paper}>
						<Grid container={true} spacing={3} alignItems="center">
							<Grid item={true} xs={true} md={4}>
								<Typography variant="h6">
									{i18n.t('ExerciseForm_0006')}
								</Typography>
							</Grid>
							<Grid
								item={true}
								xs={true}
								md={true}
								className={classes.wordBreak}
							>
								<Typography>
									{this.props.submittedReportFile}
								</Typography>
							</Grid>
							<Grid item={true} xs={true} md={2}>
								<Fab
									color="primary"
									aria-label="Download"
									onClick={this.handleDownloadReport}
								>
									<GetAppIcon />
								</Fab>
								<form
									method="POST"
									action={
										SiteConfig.tsqPath +
										'/tsq/pkg/action/el/submittedReportFileDownload.action'
									}
									ref={this.reportDownloadForm}
									target="_blank"
								>
									<input
										type="hidden"
										name="searchCondition"
										value={`{"careerID":"${careerID}","seq":"${seq}","userId":"${userId}","classID":"${classID}"}`}
									/>
									<input
										type="hidden"
										name="__tsqCookieName"
										value="TSQ_FD_1"
									/>
									<input
										type="hidden"
										name="__tsqFileType"
										value="studentReportFile"
									/>
								</form>
								{this.props.displayDeleteButton && (
									<>
										<Fab
											aria-label="Delete"
											onClick={this.handleDeleteButton}
										>
											<DeleteIcon />
										</Fab>
										{this.renderDeleteConfirm()}
									</>
								)}
							</Grid>
						</Grid>
					</Paper>
				)}
				<Grid container={true} spacing={3} alignItems="flex-end">
					<Typography
						variant="subtitle1"
						align="left"
						style={{ color: 'red', marginTop: '4px' }}
					>
						{i18n.t('Elearning_0047')}
					</Typography>
				</Grid>
				{flg !== 1 && (
					<Grid
						container={true}
						spacing={3}
						alignItems="flex-end"
						style={{ justifyContent: 'center' }}
					>
						<Grid item={true}>
							<Fab
								color="default"
								variant="extended"
								size="large"
								onClick={this.returnExerciseScreen}
							>
								{i18n.t('ExerciseForm_0007')}
							</Fab>
						</Grid>
					</Grid>
				)}

				<MessageDialog
					open={this.state.openErrorMessageDialog}
					showCancelButton={false}
					title={i18n.t('ExerciseForm_0008')}
					contents={this.state.messages}
					onClose={this.errorMessageDialogClose}
					onClickOk={this.errorMessageDialogClose}
				/>
				<MessageDialog
					open={this.state.openDialog}
					showCancelButton={true}
					title={i18n.t('ExerciseForm_0009')}
					contents={this.state.messages}
					onClose={this.handleDeleteConfirm}
					onClickOk={this.updateExercise}
				/>
				<Dialog
					open={this.state.openSubject}
					onClose={this.handleCloseSubject}
					aria-labelledby="simple-dialog-title"
				>
					<DialogTitle id="alert-dialog-slide-title">
						確認
					</DialogTitle>
					<DialogContent>
						<DialogContentText id="alert-dialog-slide-description">
							{i18n.t('ExerciseForm_0015')}
						</DialogContentText>
					</DialogContent>
					<DialogActions>
						<Button
							onClick={this.handleCloseSubject}
							color="primary"
						>
							{'はい'}
						</Button>
					</DialogActions>
				</Dialog>
			</div>
		);
	}

	protected returnExerciseScreen = () => {
		const portalFlg = localStorage.getItem('portalFlg');
		if (portalFlg === '0') {
			funcClose();
			return;
		}
		let to = Routes.getPath(Screens.PERSONAL_EXERCISE);
		to = to.replace(/\/:career_id/, `/${this.props.careerID}`);
		to = to.replace(/\/:class_id/, `/${this.props.classID}`);
		this.props.pushHistory(to);
	};

	/**
	 * エラーメッセージクローズ
	 */
	protected errorMessageDialogClose() {
		this.setState({ openErrorMessageDialog: false, messages: [] });
	}

	/*
	 * 削除確認ダイアログのレンダリング
	 */
	protected renderDeleteConfirm() {
		return (
			<Dialog
				open={this.state.openDeleteConfirm}
				onClose={this.handleCloseDeleteConfirm}
				aria-labelledby="simple-dialog-title"
			>
				<DialogContent>
					<DialogContentText id="alert-dialog-slide-description">
						{i18n.t('ExerciseForm_0010')}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={this.handleDelete} color="primary">
						{i18n.t('ExerciseForm_0011')}
					</Button>
					<Button onClick={this.handleCloseDeleteConfirm}>
						{i18n.t('ExerciseForm_0012')}
					</Button>
				</DialogActions>
			</Dialog>
		);
	}

	/**
	 * 削除ボタン押下時ハンドラ
	 */
	protected handleDeleteButton = () => {
		this.setState({ openDeleteConfirm: true });
	};

	/**
	 * 削除確認ダイアログクローズハンドラ
	 */
	protected handleCloseDeleteConfirm = () => {
		this.setState({ openDeleteConfirm: false });
	};

	/**
	 * 課題提出済のSnackbarクローズハンドラ
	 */
	protected handleCloseSubject = () => {
		this.setState({ openSubject: false });
	};

	/**
	 * 削除確認ダイアログのOKボタンハンドラ
	 */
	protected handleDelete = () => {
		this.setState({
			openDeleteConfirm: false,
		});
		this.props.deleteExerciseFile(this.props.token, {
			careerID: this.props.careerID,
			classID: this.props.classID,
			isPreview: this.props.preview,
			seq: this.props.seq,
			userAttr: this.props.userAttr,
		});
	};

	/**
	 * 課題テンプレートのダウンロード押下時ハンドラ
	 */
	protected handleDownloadTemplate = () => {
		if (this.templateDownloadForm.current) {
			this.templateDownloadForm.current.submit();
		}
	};

	/**
	 * アップロードハンドラ
	 */
	protected handleUpload = () => {
		if (!this.state.uploadFilename) {
			const messages: IMessage[] = [];
			const message: IMessage = {
				content: 'LMCM_E_10210',
			};
			messages.push(message);
			this.setState({
				messages,
				openErrorMessageDialog: true,
			});
		} else if (!this.state.uploadFile) {
			const messages: IMessage[] = [];
			const message: IMessage = {
				content: 'LMCM_E_10211',
			};
			messages.push(message);
			this.setState({
				messages,
				openErrorMessageDialog: true,
			});
		} else {
			if (this.props.submittedReportFile) {
				const messages: IMessage[] = [];
				const message: IMessage = {
					content: 'LMCM_C_00692',
				};
				messages.push(message);
				this.setState({
					messages,
					openDialog: true,
				});
			} else {
				this.updateExercise();
			}
		}
	};

	// 提出済み課題のダウンロード押下時ハンドラ
	protected handleDownloadReport = () => {
		if (this.reportDownloadForm.current) {
			this.reportDownloadForm.current.submit();
		}
	};

	// ファイル名入力時のハンドラ
	protected handleUploadFilename = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		const uploadFilename = target.value;
		this.setState({
			uploadFilename,
		});
	};

	// ファイル選択時のハンドラ
	protected handleSelectFile = (
		event: React.ChangeEvent<HTMLInputElement>
	) => {
		const target = event.target as HTMLInputElement;
		const uploadFile = target.value;
		this.setState({
			uploadFile,
		});
	};

	// 添付ボタン押下時ハンドラ
	protected handleClickAttachment = () => {
		if (!this.uploadInput.current) {
			return;
		}
		this.uploadInput.current.click();
	};

	protected getFilename(fullpath: string) {
		return fullpath.replace(/^.+[\\\/]/, '');
	}

	// 課題更新
	protected updateExercise = () => {
		this.setState({ openDialog: false });
		if (this.state.uploadFilename.length > 128) {
			const messages: IMessage[] = [];
			const message: IMessage = {
				content: 'CHK_E_0004',
				replacements: [i18n.t('ExerciseForm_0013'), '128'],
			};
			messages.push(message);
			this.setState({
				messages,
				openErrorMessageDialog: true,
			});
			return;
		}

		if (!this.uploadForm.current) {
			return;
		}
		const form = new FormData(this.uploadForm.current);
		const modelData = {
			el_el_ELearningReportBlockModel: {
				accessType: '10',
				careerID: this.props.careerID,
				classID: this.props.classID,
				file: this.state.uploadFile,
				insertOrUpdateFlag: this.props.submittedReportFile,
				reportFile: this.state.uploadFilename,
				reportFileName: this.getFilename(this.state.uploadFile),
				seq: this.props.seq,
				userId: this.props.userAttr.userId,
			},
		};
		form.append('__modelData', JSON.stringify(modelData));
		const request = new XMLHttpRequest();
		request.open(
			'POST',
			SiteConfig.tsqPath + '/tsq/ui/common/resources/rest/file/upload',
			true
		);
		request.setRequestHeader(
			'Accept',
			'application/json, text/javascript, */*; q=0.01'
		);
		request.onreadystatechange = () => {
			if (request.readyState === 4 && request.status === 200) {
				const errorModel = JSON.parse(request.responseText);
				const errorCode =
					errorModel.el_el_ELearningReportBlockModel.errorCode;
				const reportFileMaxLimitSize =
					errorModel.el_el_ELearningReportBlockModel
						.reportFileMaxLimitSize;
				if (errorCode !== null && errorCode !== '') {
					const messages: IMessage[] = [];
					if (
						reportFileMaxLimitSize !== null &&
						reportFileMaxLimitSize !== ''
					) {
						const message: IMessage = {
							content: errorCode,
							replacements: [reportFileMaxLimitSize],
						};
						messages.push(message);
						// 表示
						if (messages.length !== 0) {
							this.setState({
								messages,
								openErrorMessageDialog: true,
							});
						}
					} else {
						const message: IMessage = {
							content: errorCode,
						};
						messages.push(message);
						// 表示
						if (messages.length !== 0) {
							this.setState({
								messages,
								openErrorMessageDialog: true,
							});
						}
					}
					return;
				}

				this.props.fetchExerciseStatus(this.props.token, {
					careerID: this.props.careerID,
					classID: this.props.classID,
					isPreview: this.props.preview,
					seq: this.props.seq,
					userAttr: this.props.userAttr,
				});
				this.setState({
					uploadFile: '',
					uploadFilename: '',
				});
				if (this.uploadInput.current) {
					this.uploadInput.current.value = '';
				}
				this.props.fetchELearningTree(this.props.token, {
					careerID: this.props.careerID,
					classID: this.props.classID,
					isPreview: this.props.preview,
					userAttr: this.props.userAttr,
				});
			}
		};
		request.send(form);
	};

	protected handleDeleteConfirm = () => {
		this.setState({ openDialog: false });
	};
}

export const mapStateToProps = (state: IRootState) => ({
	displayDeleteButton: state.exerciseForm.displayDeleteButton,
	displayDownloadButton: state.exerciseForm.displayDownloadButton,
	displaySubmittedReportDownloadButton:
		state.exerciseForm.displaySubmittedReportDownloadButton,
	displayUploadButton: state.exerciseForm.displayUploadButton,
	reportName: state.exerciseForm.reportName,
	reportTemplateFileName: state.exerciseForm.reportTemplateFileName,
	resultStatus: state.exerciseForm.resultStatus,
	submittedReportFile: state.exerciseForm.submittedReportFile,

	token: state.session.token,
	userAttr: state.session.userAttr,
});

export const mapDispatchToProps = (dispatch: Dispatch) => ({
	/** 課題ページ初期化 */
	init: (payload: IFetchELearningProgressParam) =>
		dispatch(Actions.initExcerciseForm(payload)),

	clearExerciseFormParams: () =>
		dispatch(Actions.clearExerciseFormParams({})),
	deleteExerciseFile: (token: string, arg: IDeleteExerciseFileParam) => {
		const s = ScenarioFactory.createDeleteExerciseFile(dispatch, token);
		s.run(arg);
	},
	fetchExerciseStatus: (token: string, arg: IFetchExerciseStatusParam) => {
		const s = ScenarioFactory.createFetchExerciseStatus(dispatch, token);
		s.run(arg);
	},

	fetchELearningTree: (token: string, arg: IFetchELearningTreeParam) => {
		const s = ELearningScenarioFactory.createFetchELearningTree(
			dispatch,
			token
		);
		s.run(arg);
	},

	pushHistory: (path: string) => dispatch(push(path)),
});

export interface IExerciseFormProps extends IELearningCommonProps {
	seq: string;
	flg: number;
	subjectStatusflg: string;
}

const mergeProps = (
	state: IStateProps,
	events: IDispatchProps,
	ownProps: IOwnProps
) => ({
	...state,
	...events,
	...ownProps,
});

type IStateProps = ReturnType<typeof mapStateToProps>;
type IDispatchProps = ReturnType<typeof mapDispatchToProps>;
type IOwnProps = WithStyles<typeof styles> & IExerciseFormProps;
type IProps = ReturnType<typeof mergeProps>;

const Connected = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(ExerciseFormComponent);

const ExerciseForm = withStyles(styles)(Connected);
ExerciseForm.displayName = 'ExerciseForm';

export default ExerciseForm;



// WEBPACK FOOTER //
// ./src/containers/ExerciseForm.tsx